import { MessageCircle, Phone } from "lucide-react";
import { BRAND, waLink } from "@/config/brand";
import { LeadForm } from "./LeadForm";
import { Reveal } from "./Reveal";

export const CtaBand = () => (
  <section id="consult" data-testid="cta-section" className="bg-white pb-20 lg:pb-28">
    <div className="mx-auto max-w-[1280px] px-5 lg:px-8">
      <div className="overflow-hidden rounded-3xl bg-ink px-6 py-12 sm:px-10 lg:px-14 lg:py-16">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12">
          <div className="lg:col-span-6">
            <Reveal>
              <span className="eyebrow text-brand">Talk to an advisor</span>
              <h2 className="mt-5 font-display text-3xl font-extrabold leading-tight text-white sm:text-4xl lg:text-5xl">
                Tell us your budget. We&apos;ll tell you the truth.
              </h2>
              <p className="mt-5 max-w-lg text-base leading-relaxed text-white/70">
                One call is enough to know whether the NH-24 corridor fits your plan — and which
                sector deserves your money this quarter.
              </p>
              <div className="mt-8 flex flex-wrap gap-3">
                <a
                  href={`tel:${BRAND.phone}`}
                  data-testid="cta-call-btn"
                  className="flex items-center gap-2 rounded-full bg-brand px-6 py-3.5 text-sm font-bold text-white transition-colors hover:bg-brandDark"
                >
                  <Phone className="h-4 w-4" /> {BRAND.phoneDisplay}
                </a>
                <a
                  href={waLink()}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="cta-whatsapp-btn"
                  className="flex items-center gap-2 rounded-full bg-white/10 px-6 py-3.5 text-sm font-semibold text-white ring-1 ring-white/20 transition-colors hover:bg-white/15"
                >
                  <MessageCircle className="h-4 w-4" /> WhatsApp us
                </a>
              </div>
            </Reveal>
          </div>
          <div className="lg:col-span-5 lg:col-start-8">
            <LeadForm compact />
          </div>
        </div>
      </div>
    </div>
  </section>
);
